export const messages = {
  en: {
    listApplyRoomDiscountRecordDetails: {
      title: 'Decoration Records',
      back: 'Back',
      room: 'Room',
      image: 'Image/Video',
      createTime: 'Create Time'
    }
  },
  zh: {
    listApplyRoomDiscountRecordDetails: {
      title: '装修记录',
      back: '返回',
      room: '房屋',
      image: '图片/视频',
      createTime: '创建时间'
    }
  }
}